module.exports = __webpack_public_path__ + "static/media/mobile.332b2314.svg";